import React from 'react';
import { get } from 'lodash';

function FormErrorMessage({ errors = {}, name = '' }) {
  const message = get(errors, `${name}.message`, '');

  if (!message) {
    return <span></span>;
  }

  return <span className="text-red-400 text-xs">{message}</span>;
}

export default FormErrorMessage;
